document.addEventListener('DOMContentLoaded', () => {
  /* ------------------------------------------------------------------
   * Ritual video — product/lifestyle stills animated to MP4 (FAL/i2v)
   * Injects into #story if Liquid HTML is page-cached without <video>.
   * ------------------------------------------------------------------ */
  const RITUAL_URLS = {
    lifestyle:
      'https://cdn.shopify.com/s/files/1/0805/6091/4617/files/ritual-lifestyle.mp4?v=1784356226',
    product:
      'https://cdn.shopify.com/s/files/1/0805/6091/4617/files/ritual-product-serum.mp4?v=1784356229',
    poster:
      'https://cdn.shopify.com/s/files/1/0805/6091/4617/files/story-ritual.jpg?v=1784354320',
  };

  const ensureRitualPlayer = () => {
    let ritualVideo = document.getElementById('ritualVideo');
    if (ritualVideo) return ritualVideo;

    const story = document.getElementById('story');
    if (!story) return null;

    // Prefer replacing legacy #storyImg placeholder
    const legacyImg = document.getElementById('storyImg');
    const mount =
      legacyImg?.parentElement ||
      story.querySelector('.rounded-\\[2rem\\]') ||
      story.querySelector('[class*="rounded"]') ||
      story.querySelector('.grid > div:last-child');

    if (!mount) return null;

    mount.classList.add('relative', 'group', 'overflow-hidden');
    mount.innerHTML = `
      <video id="ritualVideo" class="h-[28rem] w-full object-cover" playsinline muted loop preload="metadata"
        poster="${RITUAL_URLS.poster}"
        data-ritual-src="${RITUAL_URLS.lifestyle}"
        data-product-src="${RITUAL_URLS.product}">
        <source src="${RITUAL_URLS.lifestyle}" type="video/mp4">
      </video>
      <div id="storyGlow" class="pointer-events-none absolute inset-0 bg-[#c2622f]/10 opacity-20"></div>
      <button type="button" data-ritual-play class="absolute inset-0 flex items-center justify-center bg-[#1c1915]/25 hover:bg-[#1c1915]/35 transition-colors" aria-label="Play ritual video">
        <span class="inline-flex h-16 w-16 items-center justify-center rounded-full bg-white/90 text-[#1c1915] shadow-xl">
          <iconify-icon icon="solar:play-bold" class="text-3xl ml-0.5"></iconify-icon>
        </span>
      </button>
      <div class="absolute bottom-4 left-4 right-4 flex flex-wrap gap-2 z-10">
        <button type="button" data-ritual-src-switch="ritual" class="rounded-full bg-white/90 px-3 py-1.5 text-xs font-medium text-[#1c1915] backdrop-blur hover:bg-white">Ritual scene</button>
        <button type="button" data-ritual-src-switch="product" class="rounded-full bg-white/70 px-3 py-1.5 text-xs font-medium text-[#1c1915]/80 backdrop-blur hover:bg-white">C-Radiance still</button>
      </div>`;

    if (!document.getElementById('ritual-modal')) {
      const modal = document.createElement('div');
      modal.id = 'ritual-modal';
      modal.className =
        'fixed inset-0 z-[80] hidden items-center justify-center bg-[#1c1915]/70 p-4 backdrop-blur-sm';
      modal.setAttribute('role', 'dialog');
      modal.innerHTML = `
        <div class="relative w-full max-w-4xl overflow-hidden rounded-3xl bg-[#1c1915] shadow-2xl">
          <button type="button" id="ritual-modal-close" class="absolute right-3 top-3 z-10 grid h-10 w-10 place-items-center rounded-full bg-white/10 text-white hover:bg-white/20" aria-label="Close">
            <iconify-icon icon="solar:close-circle-bold-duotone" class="text-2xl"></iconify-icon>
          </button>
          <video id="ritualModalVideo" class="aspect-video w-full bg-black object-contain" controls playsinline preload="metadata" poster="${RITUAL_URLS.poster}">
            <source src="${RITUAL_URLS.lifestyle}" type="video/mp4">
          </video>
        </div>`;
      document.body.appendChild(modal);
    }

    // Upgrade hero "Watch the ritual" links/buttons
    document.querySelectorAll('a[href="#story"]').forEach((a) => {
      if ((a.textContent || '').toLowerCase().includes('ritual')) {
        a.setAttribute('data-ritual-play', '1');
        a.setAttribute('href', '#story');
        if (!a.id) a.id = 'ritual-play-btn';
      }
    });

    return document.getElementById('ritualVideo');
  };

  const ritualVideo = ensureRitualPlayer();
  const modal = document.getElementById('ritual-modal');
  const modalVideo = document.getElementById('ritualModalVideo');
  const modalClose = document.getElementById('ritual-modal-close');

  const openRitualModal = () => {
    if (!modal || !modalVideo) return;
    const src =
      (ritualVideo && (ritualVideo.currentSrc || ritualVideo.getAttribute('data-ritual-src'))) ||
      RITUAL_URLS.lifestyle;
    if (src) modalVideo.src = src;
    modal.classList.remove('hidden');
    modal.classList.add('flex');
    document.body.style.overflow = 'hidden';
    modalVideo.play().catch(() => {});
  };

  const closeRitualModal = () => {
    if (!modal || !modalVideo) return;
    modalVideo.pause();
    modal.classList.add('hidden');
    modal.classList.remove('flex');
    document.body.style.overflow = '';
  };

  document.querySelectorAll('[data-ritual-play]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      const story = document.getElementById('story');
      if (story) story.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (btn.id === 'ritual-play-btn' || btn.getAttribute('href') === '#story') {
        openRitualModal();
      } else if (ritualVideo) {
        ritualVideo.muted = true;
        ritualVideo.play().catch(() => openRitualModal());
        btn.classList.add('opacity-0', 'pointer-events-none');
      } else {
        openRitualModal();
      }
    });
  });

  if (modalClose) modalClose.addEventListener('click', closeRitualModal);
  if (modal) {
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeRitualModal();
    });
  }
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeRitualModal();
  });

  document.querySelectorAll('[data-ritual-src-switch]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      if (!ritualVideo) return;
      const kind = btn.getAttribute('data-ritual-src-switch');
      const next =
        kind === 'product'
          ? ritualVideo.getAttribute('data-product-src') || RITUAL_URLS.product
          : ritualVideo.getAttribute('data-ritual-src') || RITUAL_URLS.lifestyle;
      ritualVideo.pause();
      const source = ritualVideo.querySelector('source');
      if (source) source.src = next;
      ritualVideo.load();
      ritualVideo.play().catch(() => {});
      document.querySelectorAll('[data-ritual-src-switch]').forEach((b) => {
        b.classList.toggle('bg-white/90', b === btn);
        b.classList.toggle('bg-white/70', b !== btn);
      });
    });
  });

  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
  gsap.registerPlugin(ScrollTrigger);

  document.querySelectorAll('[data-reveal]').forEach((el) => {
    gsap.fromTo(
      el,
      { opacity: 0, y: 36, filter: 'blur(12px)' },
      {
        opacity: 1,
        y: 0,
        filter: 'blur(0px)',
        duration: 1.1,
        ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true },
      }
    );
  });

  ScrollTrigger.create({
    start: 60,
    onUpdate: (self) => {
      const nav = document.getElementById('nav');
      if (!nav) return;
      nav.style.transform =
        self.direction === 1 && self.scroll() > 400 ? 'translateY(-110%)' : 'translateY(0)';
    },
  });

  document.querySelectorAll('[data-parallax]').forEach((img) => {
    gsap.to(img, {
      yPercent: 8,
      ease: 'none',
      scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: 1 },
    });
  });

  document.querySelectorAll('.fl-card').forEach((card) => {
    const pos = { x: 0.5, y: 0.5 };
    const target = { x: 0.5, y: 0.5 };
    let raf = null;
    const render = () => {
      pos.x += (target.x - pos.x) * 0.18;
      pos.y += (target.y - pos.y) * 0.18;
      card.style.setProperty('--mx', pos.x * 100 + '%');
      card.style.setProperty('--my', pos.y * 100 + '%');
      if (Math.abs(target.x - pos.x) > 0.001 || Math.abs(target.y - pos.y) > 0.001) {
        raf = requestAnimationFrame(render);
      } else raf = null;
    };
    card.addEventListener('mousemove', (e) => {
      const r = card.getBoundingClientRect();
      target.x = (e.clientX - r.left) / r.width;
      target.y = (e.clientY - r.top) / r.height;
      if (!raf) raf = requestAnimationFrame(render);
    });
  });

  document.querySelectorAll('a.group, button').forEach((btn) => {
    btn.addEventListener('mousemove', (e) => {
      const r = btn.getBoundingClientRect();
      gsap.to(btn, {
        x: (e.clientX - r.left - r.width / 2) * 0.15,
        y: (e.clientY - r.top - r.height / 2) * 0.25,
        duration: 0.4,
        ease: 'power2.out',
      });
    });
    btn.addEventListener('mouseleave', () =>
      gsap.to(btn, { x: 0, y: 0, duration: 0.6, ease: 'elastic.out(1, 0.4)' })
    );
  });
});
